var config = require("../lib/config");
var moment = require("../../../../../node_modules/moment");
moment.locale((config.culture || "en").substring(0, 2));
module.exports = moment;
